import React, { useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import CustomTable from "../../common/CustomTable";
import CustomHeading from "../../common/CustomHeading";
import CustomSidebar from "../../common/CustomSidebar";
import BulkLeadUploadHistoryForm from "./BulkLeadUploadHistoryForm";
import useLeadBulkHistory from "../../../hooks/useLeadBulkHistory";
import { MdFilterListAlt } from "react-icons/md";
import BulkLeadUploadHistoryFilter from "./BulkLeadUploadHistoryFilter";
import {
  getBackgroundClass,
  interestLevel,
} from "../../../Enum/LeadEnumConstants";
import ConfirmationModal from "../../shareableContainer/ConfirmationModal";
import { ToastContainer } from "react-toastify";
const BulkLeadUploadHistoryList = () => {
  const {
    leadBulkHistory,
    getLeadBulkHistory,
    handlePageSizeChange,
    handlePageChange,
    pageSize,
    currentPage,
    nextPageToken,
    prevPageToken,
    hasMore,
    loading,
    setIsFilterOpen,
    isFilterOpen,
    handleFilterChange,
    quality,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    handleApplyFilter,
    clearFilters,
    setQuality,
    handleToggelFilter,
    formData,
    setFormData,
    handleOnViewLeads,
    setVisible,
    visible,
  } = useLeadBulkHistory();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOnRevertLeads = () => {
    setIsModalOpen(true);
    setVisible(false);
  };

  const columns = [
    {
      key: "batchId",
      title: "ID",
      render: (value, record) => (
        <span
        
          onClick={() => { 
           
            setFormData(record);
            setVisible(true);
          }}
          className="font-semibold text-blue-500 cursor-pointer"
        >
          {value}
        </span>
      ),
    },
    {
      key: "createdBy",
      title: "Upload By",
      render: (value) => <span className="text-gray-700">{value}</span>,
    },
    {
      key: "dateAndTime",
      title: "Date & Time",
      render: (value) => <span className="text-gray-500">{value}</span>,
    },
    {
      key: "leadQuality",
      title: "Lead Quality",
      render: (value) => {
        const matchedQuality = interestLevel.find(
          (item) => item.label === value
        );

        return (
          <div className="flex items-center justify-center gap-2 text-center">
            {matchedQuality?.label && (
              <>
                <img
                  src={matchedQuality.image}
                  alt={matchedQuality.label}
                  className="w-5 h-5"
                />
                <span className={`${getBackgroundClass(matchedQuality.label)}`}>
                  {matchedQuality.label || "Not Quality"}
                </span>
              </>
            )}
          </div>
        );
      },
    },
    {
      key: "totalLead",
      title: "Total Leads",
      render: (value) => (
        <span className="text-blue-600 font-medium">{value}</span>
      ),
    },
    {
      key: "validLead",
      title: "Uploaded Leads",
      render: (text , record) => (
        <span className="text-green-600 font-medium">{record?.totalLead - (record?.duplicateLeadInFile + record?.duplicateLeadInDb + record?.invalidLead)}</span>
      ),
    },

    {
      key: "duplicateLeadInFile",
      title: "Duplicate Leads In File ",
      render: (value) => (
        <span className="text-yellow-600 font-medium">{value}</span>
      ),
    },

    {
      key: "duplicateLeadInDb",
      title: "Duplicate Leads In DB",
      render: (value) => (
        <span className="text-yellow-600 font-medium">{value}</span>
      ),
    },
    {
      key: "invalidLead",
      title: "Invalid Leads",
      render: (value) => (
        <span className="text-red-600 font-medium">{value}</span>
      ),
    },
  ];
  return (
    <div>
      <AdminAppBar />
<ToastContainer/>
      <div className="w-full h-full pt-28 px-6">
        <div className="flex flex-col gap-7">
          <div className="flex justify-between items-center ">
            <CustomHeading title="Bulk Upload History" isIcon={true} />
            <div className="flex items-center gap-4">
              <button
                onClick={handleToggelFilter}
                className="bg-white  justify-between text-base font-medium w-[131px] h-[50px] rounded-[10px]   flex items-center gap-3 text-customGreen py-2 px-4  hover:bg-appGreenHover transition duration-300"
              >
                Filters
                <MdFilterListAlt />
              </button>
            </div>
          </div>
          <CustomTable
            data={leadBulkHistory}
            columns={columns}
            isPagination={true}
            pageSize={pageSize}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
            currentPage={currentPage}
            nextId={nextPageToken}
            prevId={prevPageToken}
            hasMore={hasMore}
            loading={loading}
          />
        </div>
      </div>
      <CustomSidebar
        visible={visible}
        width="600px"
        title="Bulk Lead Upload History"
        onHide={() => setVisible(false)}
        children={
          <BulkLeadUploadHistoryForm
            formData={formData}
            onViewLeads={handleOnViewLeads}
            onRevertLeads={handleOnRevertLeads}
          />
        }
      />

      <CustomSidebar
        visible={isFilterOpen}
        title="Filter"
        onHide={() => setIsFilterOpen(false)}
        children={
          <BulkLeadUploadHistoryFilter
            selectedLevel={quality}
            handleSelectChange={(value) => setQuality(value)}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            handleApplyFilter={handleApplyFilter}
            clearFilters={clearFilters}
          />
        }
      />

      <ConfirmationModal
        showModal={isModalOpen}
        title={"Revert Back Leads"}
        message={
          "Are you sure you want to revert back the leads. Once Revert back the lead it will be removed for the assigned person form the CRM?"
        }
        onCancel={() => {
          setIsModalOpen(false);
          setVisible(true);
        }}
      />
    </div>
  );
};

export default BulkLeadUploadHistoryList;
